import { render, staticRenderFns } from "./SwitchGroup.vue?vue&type=template&id=6e27899c&scoped=true&"
import script from "./SwitchGroup.vue?vue&type=script&lang=js&"
export * from "./SwitchGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e27899c",
  null
  
)

export default component.exports